import React, { useState } from "react";
import { cadastrarUBS } from "../../api/apiService";
import Navbar from "../../components/Navbar";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  Typography,
  Alert,
  CircularProgress,
} from "@mui/material";

const CadastrarUBS = () => {
  const [formData, setFormData] = useState({
    nome: "",
    telefone: "",
    endereco: {
      cep: "55850-000",
      endereco: "",
      numero: "",
      complemento: "",
      bairro: "",
      cidade: "Vicência",
      estado: "PE",
    },
  });

  const [error, setError] = useState({});
  const [mensagem, setMensagem] = useState("");
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const cidadesVizinhas = [
    "Recife",
    "Olinda",
    "Jaboatão dos Guararapes",
    "Paulista",
    "Igarassu",
    "Abreu e Lima",
    "Cabo de Santo Agostinho",
    "Carpina",
    "Timbaúba",
    "Vicência",
    "Limoeiro",
  ];

  const estadosBrasil = [
    { sigla: "AC", nome: "Acre" },
    { sigla: "AL", nome: "Alagoas" },
    { sigla: "AP", nome: "Amapá" },
    { sigla: "AM", nome: "Amazonas" },
    { sigla: "BA", nome: "Bahia" },
    { sigla: "CE", nome: "Ceará" },
    { sigla: "DF", nome: "Distrito Federal" },
    { sigla: "ES", nome: "Espírito Santo" },
    { sigla: "GO", nome: "Goiás" },
    { sigla: "MA", nome: "Maranhão" },
    { sigla: "MT", nome: "Mato Grosso" },
    { sigla: "MS", nome: "Mato Grosso do Sul" },
    { sigla: "MG", nome: "Minas Gerais" },
    { sigla: "PA", nome: "Pará" },
    { sigla: "PB", nome: "Paraíba" },
    { sigla: "PR", nome: "Paraná" },
    { sigla: "PE", nome: "Pernambuco" },
    { sigla: "PI", nome: "Piauí" },
    { sigla: "RJ", nome: "Rio de Janeiro" },
    { sigla: "RN", nome: "Rio Grande do Norte" },
    { sigla: "RS", nome: "Rio Grande do Sul" },
    { sigla: "RO", nome: "Rondônia" },
    { sigla: "RR", nome: "Roraima" },
    { sigla: "SC", nome: "Santa Catarina" },
    { sigla: "SP", nome: "São Paulo" },
    { sigla: "SE", nome: "Sergipe" },
    { sigla: "TO", nome: "Tocantins" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isLoading) return; // 🔹 Bloqueia envios duplicados

    console.log("📤 Enviando requisição para cadastrar UBS...");

    setIsLoading(true); // 🔹 Ativa o estado de carregamento

    try {
      const dataToSend = {
        nome: formData.nome,
        telefone: formData.telefone,
        endereco: {
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          cep: formData.endereco.cep,
          endereco: formData.endereco.endereco,
          numero: formData.endereco.numero,
          complemento: formData.endereco.complemento,
          bairro: formData.endereco.bairro,
          cidade: formData.endereco.cidade,
          estado: formData.endereco.estado,
        },
      };

      await cadastrarUBS(dataToSend);
      console.log("✅ Cadastro enviado com sucesso!");

      setMensagem("UBS cadastrada com sucesso!");
      setIsError(false);

      setFormData({
        nome: "",
        telefone: "",
        endereco: {
          cep: "55850000",
          endereco: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade: "Vicência",
          estado: "PE",
        },
      });
    } catch (error) {
      console.error("❌ Erro ao cadastrar UBS:", error);
      setMensagem("Erro ao cadastrar UBS. Tente novamente.");
      setIsError(true);
    } finally {
      setIsLoading(false); // 🔹 Desativa carregamento após conclusão
    }
  };

  const handleCepChange = async (e) => {
    const value = e.target.value.replace(/\D/g, "");
    const formattedCep =
      value.length <= 5 ? value : `${value.slice(0, 5)}-${value.slice(5, 8)}`;

    setFormData((prevData) => ({
      ...prevData,
      endereco: { ...prevData.endereco, cep: formattedCep },
    }));

    if (value.length === 8) {
      try {
        const response = await fetch(`https://viacep.com.br/ws/${value}/json/`);
        const data = await response.json();

        if (data.erro) {
          setError((prevErrors) => ({
            ...prevErrors,
            cep: "CEP não encontrado.",
          }));
          setFormData((prevData) => ({
            ...prevData,
            endereco: {
              ...prevData.endereco,
              endereco: "",
              bairro: "",
              cidade: "",
              estado: "",
            },
          }));
        } else {
          setError((prevErrors) => ({
            ...prevErrors,
            cep: "",
          }));
          setFormData((prevData) => ({
            ...prevData,
            endereco: {
              ...prevData.endereco,
              endereco: data.logradouro || "",
              bairro: data.bairro || "",
              cidade: data.localidade || "",
              estado: data.uf || "",
            },
          }));
        }
      } catch (err) {
        setError((prevErrors) => ({
          ...prevErrors,
          cep: "Erro ao buscar informações do CEP.",
        }));
      }
    }
  };

  return (
    <Box
      sx={{
        bgcolor: "#f5f5f5",
        minHeight: "100vh",
        p: 4,
        marginTop: "7vh",
        "@media (max-width: 720px)": {
          marginTop: "5vh",
          p: 2,
        },
      }}
    >
      <Box
        sx={{
          bgcolor: "#fff",
          borderRadius: 2,
          p: 4,
          boxShadow: 3,
          maxWidth: "900px",
          mx: "auto",
          "@media (max-width: 720px)": {
            p: 3,
          },
        }}
      >
        <Navbar />
        <Typography variant="h5" gutterBottom>
          Cadastrar UBS
        </Typography>

        {mensagem && (
          <Alert severity={isError ? "error" : "success"} sx={{ mb: 2 }}>
            {mensagem}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <TextField
              label="Nome da UBS"
              variant="outlined"
              fullWidth
              value={formData.nome}
              onChange={(e) =>
                setFormData((prevData) => ({
                  ...prevData,
                  nome: e.target.value,
                }))
              }
              required
            />

            <TextField
              label="Telefone"
              variant="outlined"
              fullWidth
              value={formData.telefone}
              onChange={(e) =>
                setFormData((prevData) => ({
                  ...prevData,
                  telefone: e.target.value,
                }))
              }
            />

            <TextField
              label="CEP"
              variant="outlined"
              fullWidth
              value={formData.endereco.cep}
              onChange={handleCepChange}
              required
              error={!!error.cep}
              helperText={error.cep || ""}
            />

            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                label="Endereço"
                variant="outlined"
                fullWidth
                value={formData.endereco.endereco}
                onChange={(e) =>
                  setFormData((prevData) => ({
                    ...prevData,
                    endereco: {
                      ...prevData.endereco,
                      endereco: e.target.value,
                    },
                  }))
                }
                required
              />

              <TextField
                label="Número"
                variant="outlined"
                fullWidth
                sx={{ maxWidth: "120px" }}
                value={formData.endereco.numero}
                onChange={(e) =>
                  setFormData((prevData) => ({
                    ...prevData,
                    endereco: { ...prevData.endereco, numero: e.target.value },
                  }))
                }
              />
            </Box>

            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                label="Complemento"
                variant="outlined"
                fullWidth
                value={formData.endereco.complemento}
                onChange={(e) =>
                  setFormData((prevData) => ({
                    ...prevData,
                    endereco: {
                      ...prevData.endereco,
                      complemento: e.target.value,
                    },
                  }))
                }
              />

              <TextField
                label="Bairro"
                variant="outlined"
                fullWidth
                value={formData.endereco.bairro}
                onChange={(e) =>
                  setFormData((prevData) => ({
                    ...prevData,
                    endereco: { ...prevData.endereco, bairro: e.target.value },
                  }))
                }
              />
            </Box>

            <Box sx={{ display: "flex", gap: 2 }}>
              <FormControl fullWidth>
                <InputLabel>Cidade</InputLabel>
                <Select
                  labelId="cidade-label"
                  value={formData.endereco.cidade}
                  onChange={(e) =>
                    setFormData((prevData) => ({
                      ...prevData,
                      endereco: {
                        ...prevData.endereco,
                        cidade: e.target.value,
                      },
                    }))
                  }
                >
                  {cidadesVizinhas.map((cidade) => (
                    <MenuItem key={cidade} value={cidade}>
                      {cidade}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel>Estado</InputLabel>
                <Select
                  value={formData.endereco.estado}
                  onChange={(e) =>
                    setFormData((prevData) => ({
                      ...prevData,
                      endereco: {
                        ...prevData.endereco,
                        estado: e.target.value,
                      },
                    }))
                  }
                >
                  {estadosBrasil.map((estado) => (
                    <MenuItem key={estado.sigla} value={estado.sigla}>
                      {estado.nome}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <Button
              variant="contained"
              color="primary"
              type="submit"
              fullWidth
              disabled={isLoading} // 🔹 Evita múltiplos envios
            >
              {isLoading ? (
                <CircularProgress size={24} style={{ color: "white" }} />
              ) : (
                "Cadastrar"
              )}
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  );
};

export default CadastrarUBS;
